import gql from "graphql-tag";

export const BUY_ASSET_IN_FIAT = gql`
mutation Mutation($tokenId: String!, $storeId: MID) {
    buyAssetInFiat(tokenId: $tokenId, storeId: $storeId) {
      order_id
      totel_amount
      currency
      amount_break_down
    }
  }
`